<template>
  <transition name="toast-fade">
    <div
      v-show="visible"
      class="fixed left-1/2 top-6 -translate-x-1/2 z-[9999] max-w-[90vw] px-4 py-2 rounded-lg shadow-lg border text-sm"
      :class="type === 'error' ? 'bg-red-50 border-red-200 text-red-700' : 'bg-green-50 border-green-200 text-green-700'"
      role="status"
      aria-live="polite"
    >
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GlobalToast',
  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, default: '' },
    type: { type: String, default: 'success' }
  },
  mounted () {
    // 确保不受父级弹窗的 overflow/层叠上下文影响
    if (this.$el && this.$el.parentNode !== document.body) {
      document.body.appendChild(this.$el)
    }
  },
  beforeDestroy () {
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el)
    }
  }
}
</script>

<style>
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -6px);
}
</style>

